import * as React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './Clients.css';
import { clients } from '../../data/ClientsData';
import * as Scroll from 'react-scroll';

export class Clients extends React.Component<any,{}> {

  private clientDom = clients.map((client, index) => {
    return (
      <Col xs="6" sm="4" md="3" lg="2" className="logo" key={index}>
        <a href={client.url} title={client.name} className="client-container">
          <img src={client.logo_url} alt={client.name} />
        </a>
      </Col>
    );
  });

  render() {
    return (
      <section className="page-section" id="clients-section">
        <Scroll.Element name="clients">
          <Container tag="article">
            <header className="section-header">
              <Row>
                <Col xs="12">
                  <h1>Asiakkaat</h1>
                  <p className="lead">Meillä on kunnia työskennellä monien eri alojen yritysten ja ammattilaisten kanssa. Haluamme ansaita asiakkaidemme luottamuksen hyvällä palvelulla, suunnittelutyön korkealla laadulla ja sitoutumisella.</p>
                </Col>
              </Row>
            </header>
            <Row className="client-grid">
              { this.clientDom }
            </Row>
          </Container>
        </Scroll.Element>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/clients/Clients.tsx